export function fiGetArrayFilledWithIndexes(arraySize: number): number[] {
    return [...new Array(arraySize)].map((_, index: number) => index);
}
